import { Query, useMutation, useQueryClient } from '@tanstack/react-query';
import useFilterStudiesInfiniteQuery, {
  FILTERED_STUDIES_LIMIT,
  filterStudiesQueryOptions,
} from 'app/queries/useFilterStudiesInfiniteQuery';
import ApiCalls from 'app/utils/apiCalls';
import _ from 'lodash';

export default function useDeleteStudyMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [{ query: '/study/delete', type: 'DELETE' }],
    mutationFn: async ({ studyIDs }: { studyIDs: string[] }) => {
      await ApiCalls.deleteStudies(studyIDs);

      // First use of setQueriesData for optimistic update
      queryClient.setQueriesData(
        {
          ...filterStudiesQueryOptions(undefined),
          exact: false,
          predicate: (query: Query<ReturnType<typeof useFilterStudiesInfiniteQuery>['data']>) =>
            _.some(query.state.data?.pages, (page) =>
              _.some(page, (study) => studyIDs.includes(study._id))
            ),
        },
        (oldData) => {
          const newPages = _(oldData.pages)
            .flatten()
            .reject((study) => studyIDs.includes(study._id))
            .chunk(FILTERED_STUDIES_LIMIT)
            .value();
          return { ...oldData, pages: newPages };
        }
      );
    },
  });
}
